import { render, staticRenderFns } from "./Otherfees.vue?vue&type=template&id=5eaa81c0&scoped=true&"
import script from "./Otherfees.vue?vue&type=script&lang=js&"
export * from "./Otherfees.vue?vue&type=script&lang=js&"
import style0 from "./Otherfees.vue?vue&type=style&index=0&id=5eaa81c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eaa81c0",
  null
  
)

export default component.exports